// V 1.2
const HCACMAP = new Map();
window.getHCAccordion = (el) => HCACMAP.get(el);

class Accordion {
  constructor(element, trigger, content, speed = 0.7, maxTransitionTime = 2) {
    this.el = element;
    if(this.el.querySelector(trigger)) {
      this.el
        .querySelector(trigger)
        .addEventListener("click", this.clickListener);
    }
    this.el.style.overflow = "hidden";
    this.selectors = { trigger, content };
    this.opened = this.el.hasAttribute("opened");
    this.maxTransitionTime = maxTransitionTime;
    this.speed = speed;

    window.addEventListener("resize", () => (this.opened = this.opened));

    HCACMAP.set(this.el, this);

    this.el.classList.add("loaded");
  }
  clickListener = (e) => {
    const accordion = HCACMAP.get(e.currentTarget.closest("[hc-accordion-tab]"));
    if (accordion) accordion.trigger();
  }

  get triggerEl() {
    return (
      this._trigger ||
      (this._trigger = this.el.querySelector(this.selectors.trigger))
    );
  }

  get contentEl() {
    return (
      this._content ||
      (this._content = this.el.querySelector(this.selectors.content))
    );
  }

  set opened(val) {
    if(this.contentEl && this.triggerEl) {
      let duration = (this.contentEl.offsetHeight / 100) * this.speed;
      if (duration > this.maxTransitionTime) duration = this.maxTransitionTime;
      this.el.style.transitionDuration = duration + "s";

      this._opened = val;
      if (val) {
        this.el.style.height =
          this.triggerEl.offsetHeight + this.contentEl.offsetHeight + "px";
        setTimeout(
          () => this._opened && (this.el.style.height = "auto"),
          duration * 1000,
        );
      } else {
        this.el.style.height =
          this.triggerEl.offsetHeight + this.contentEl.offsetHeight + "px";
        setTimeout(
          () =>
            !this._opened &&
            (this.el.style.height = this.triggerEl.offsetHeight + "px"),
        );
      }
      this.el.classList.toggle("hc--opened", val);
    }
  }

  open() {
    this.opened = true;
    this.el.dispatchEvent(new CustomEvent("hc:open"));
  }

  close() {
    this.opened = false;
    this.el.dispatchEvent(new CustomEvent("hc:close"));
  }

  get opened() {
    return this._opened;
  }
  trigger() {
    if (this.opened) this.close();
    else this.open();
  }
  unlink() {
    this.triggerEl.removeEventListener("click", this.clickListener);
    HCACMAP.delete(this.el);
  }
  destroy() {
    this.unlink();
    this.el.classList.remove("loaded");
    this.el.style.height = "auto";
    this._trigger = null;
    this._content = null;
  }
}
const initAccordion = (el) => {
  // If already initialized destroy it
  const existing = HCACMAP.get(el);
  if (existing) existing.destroy();

  let speed, maxT;
  if (el.dataset.speed) speed = parseFloat(el.dataset.speed);
  if (el.dataset.maxTransisionTime)
    maxT = parseFloat(el.dataset.maxTransisionTime);
  new Accordion(
    el,
    "[hc-accordion-header]",
    "[hc-accordion-content]",
    speed,
    maxT,
  );
};
document.querySelectorAll("[hc-accordion-tab]").forEach((el) => {
  initAccordion(el);
});
const observer = new MutationObserver((mutationsList, observer) => {
  const selector = "[hc-accordion-tab]";
  for (const mutation of mutationsList) {
    if (mutation.type === "childList") {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) {
          if (node.matches(selector)) {
            initAccordion(node);
          } else if (node.querySelector(selector)) {
            node.querySelectorAll(selector).forEach((el) => initAccordion(el));
          }
        }
      });
    }
  }
});
observer.observe(document.body, { childList: true, subtree: true });
